import { MutationTuple, useMutation } from '@apollo/client';
import { COMPLETE_ACTIVITY_ASSIGNMENT_MUTATION } from 'graphql/activityAssignments/mutations/completeActivityAssignment.gql';
import {
  CompleteActivityAssignmentMutation,
  CompleteActivityAssignmentMutationVariables,
} from '__generated__/graphql';

export default function useMutationCompleteActivityAssignment(): MutationTuple<
  CompleteActivityAssignmentMutation,
  CompleteActivityAssignmentMutationVariables
> {
  return useMutation(COMPLETE_ACTIVITY_ASSIGNMENT_MUTATION);
}
